import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery, select } from "redux-saga/effects";

import { alert } from "../../../../Utils/toast";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { ChoosePurchaseModelDataTypes } from "../../../../Schema/choosePurchaseModel.types";
import { queryClient } from "../../../store";
import Cookies from "js-cookie";

export type WalletCashInLoadAction = {
  type: string;
  payload: {
    amount: string | number;
  };
};

export type WalletCashInData = {
  data: ChoosePurchaseModelDataTypes;
};

const WalletCashIn = new ReduxFetchState<WalletCashInData, { amount: string | number }, any>(
  "walletCashIn",
);

export function* watchWalletCashIn(action: WalletCashInLoadAction) {
  try {
    const { amount } = action.payload;

    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: WalletCashInData = yield axios({
      headers: {
        lang,
      },
      url: "/api/v1/ai/user/wallet/cash-in",
      method: "POST",
      data: { amount: amount, callback_url: window.location.href },
    });

    queryClient.removeQueries({ queryKey: ["checkLogin", lang] });
    Cookies.remove("checkLogin", { domain: ".lamtakam.com" });
    queryClient.removeQueries({ queryKey: ["getProfile", lang] });
    queryClient.removeQueries({ queryKey: ["getSubscriptionPlans", lang] });

    if (data.data.redirect_link) {
      window.location.href = data.data.redirect_link;
    }

    yield put(WalletCashIn.actions.loadSuccess({ data: data.data }));
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(WalletCashIn.actions.loadFailure(e.message));
  }
}

export function* walletCashInSagas() {
  yield takeEvery(WalletCashIn.actionTypes.load, watchWalletCashIn);
}

export function useWalletCashIn() {
  const { loading, data, ...walletCashInState } = useAppSelector((state) => state.walletCashIn);
  const dispatch = useAppDispatch();

  const dispatchWalletCashIn = useCallback(
    (data: { amount: string | number }) => {
      dispatch(WalletCashIn.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...walletCashInState,
    dispatchWalletCashIn,
    walletCashInLoading: loading,
    walletCashInData: data,
  };
}

export const {
  actionTypes: walletCashInActionsTypes,
  actions: walletCashInActions,
  reducer: walletCashInReducer,
} = WalletCashIn;
